module.exports = __webpack_public_path__ + "static/media/recruitment-3.0938c22c.png";